var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVectorRed({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1699,
    height: 1764,
    viewBox: "0 0 1699 1764",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1588 578.609L1451.7 817.309L1397.12 784.656L1224.08 896.17L1122.68 1073.66L1123.23 1159.46L1197.94 1167.93L1264.76 1144.87L1136.81 1368.43C1136.81 1368.43 1082.78 1350.73 1038.71 1346.32C1015.45 1344.02 984.634 1343.44 969.912 1343.57L820.951 1602L255.329 789.61L324.765 668.009L111 361.302L282.847 60H1122.68L1551.95 319.777L1452.34 496.505L1588 578.609Z",
    fill: "#C2191E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 1699,
    height: 1764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 11,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTY5OSIgaGVpZ2h0PSIxNzY0IiB2aWV3Qm94PSIwIDAgMTY5OSAxNzY0IiBmaWxsPSJ3aGl0ZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9kKSI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1ODggNTc4LjYwOUwxNDUxLjcgODE3LjMwOUwxMzk3LjEyIDc4NC42NTZMMTIyNC4wOCA4OTYuMTdMMTEyMi42OCAxMDczLjY2TDExMjMuMjMgMTE1OS40NkwxMTk3Ljk0IDExNjcuOTNMMTI2NC43NiAxMTQ0Ljg3TDExMzYuODEgMTM2OC40M0MxMTM2LjgxIDEzNjguNDMgMTA4Mi43OCAxMzUwLjczIDEwMzguNzEgMTM0Ni4zMkMxMDE1LjQ1IDEzNDQuMDIgOTg0LjYzNCAxMzQzLjQ0IDk2OS45MTIgMTM0My41N0w4MjAuOTUxIDE2MDJMMjU1LjMyOSA3ODkuNjFMMzI0Ljc2NSA2NjguMDA5TDExMSAzNjEuMzAyTDI4Mi44NDcgNjBIMTEyMi42OEwxNTUxLjk1IDMxOS43NzdMMTQ1Mi4zNCA0OTYuNTA1TDE1ODggNTc4LjYwOVoiIGZpbGw9IiNDMjE5MUUiLz4KICA8L2c+CiAgPGRlZnM+CiAgICA8ZmlsdGVyIGlkPSJmaWx0ZXIwX2QiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjk5IiBoZWlnaHQ9IjE3NjQiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KICAgICAgPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KICAgICAgPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiLz4KICAgICAgPGZlTW9ycGhvbG9neSByYWRpdXM9IjExIiBvcGVyYXRvcj0iZGlsYXRlIiBpbj0iU291cmNlQWxwaGEiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93Ii8+CiAgICAgIDxmZU9mZnNldCBkeT0iNTEiLz4KICAgICAgPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNTAiLz4KICAgICAgPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMjUgMCIvPgogICAgICA8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvdyIvPgogICAgICA8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJzaGFwZSIvPgogICAgPC9maWx0ZXI+CiAgPC9kZWZzPgo8L3N2Zz4K";
export { SvgVectorRed as ReactComponent };